<div fxFlex="0 0 100%">
    <ng-container #controlPlaceHolder></ng-container>
</div>